import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveTextstyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"remove-textstyle"} maskId="square-filled-radius-0-stroke-1-IconRemoveTextstyle"><path fillRule="evenodd" clipRule="evenodd" d="M2.46054 2.79419L21.2086 19.4275L20.5449 20.1756L11.3373 12.0066L10.1871 21.0591L9.19512 20.933L10.4314 11.2028L1.79688 3.54222L2.46054 2.79419ZM8.00272 3.00004H20.0027V4.00004H12.3546L11.7118 9.05907L10.7198 8.93303L11.3466 4.00004H8.00272V3.00004Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconRemoveTextstyle;
